import {atom, DefaultValue, selector} from 'recoil';

const loginUsernameState = atom({
  key: 'login_form_username',
  default: '',
});

const loginPasswordState = atom({
  key: 'login_form_password',
  default: '',
});

const loginLoadingState = atom({
  key: 'login_form_loading',
  default: false,
});

const loginErrorState = atom({
  key: 'login_form_Error',
  default: '',
});

const loginFormState = selector({
  key: 'loginForm',
  get: ({get}) => {
    // get values from individual atoms:
    const username = get(loginUsernameState);
    const password = get(loginPasswordState);
    const loading = get(loginLoadingState);
    const error = get(loginErrorState);
    return {username, password, loading, error};
  },
  set: ({set}, value) => {
    // in a Reset action, the value will be DefaultValue (read more in selector docs):
    if (value instanceof DefaultValue) {
      set(loginUsernameState, value);
      set(loginPasswordState, value);
      set(loginLoadingState, value);
      set(loginErrorState, value)
      return;
    }
    // otherwise, update individual atoms from new object state:
    set(loginUsernameState, value.username);
    set(loginPasswordState, value.password);
    set(loginLoadingState, value.loading);
    set(loginErrorState, value.error);
  },
});

export { loginFormState }